var React = require('react');

function Staging (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2.000000, 2.000000)","strokeWidth":"3"},[React.createElement("path",{"d":"M4.65517241,0 L4.65517241,17.6896552","key":0}),React.createElement("circle",{"cx":"22.3448276","cy":"4.65517241","r":"4.65517241","key":1}),React.createElement("circle",{"cx":"4.65517241","cy":"22.3448276","r":"4.65517241","key":2}),React.createElement("path",{"d":"M22.3448276,10.3793103 C22.3448276,16.987683 16.987683,22.3448276 10.3793103,22.3448276","key":3})]));
}

Staging.defaultProps = {"fill":"none","stroke":"currentColor","viewBox":"0 0 31 31","version":"1.1"};

module.exports = Staging;

Staging.default = Staging;
